import type { QueryClient } from "@tanstack/react-query";

// A flag closing (reply, outbound call, Status) changes every surface at once
// (AC.17), so they refresh together.
const FOLLOW_UP_QUERY_ROOTS = [
  ["NOTIFICATIONS"],
  ["UNREAD_NOTIFICATIONS_COUNT"],
  ["TOTAL_UNREAD_NOTIFICATIONS"],
  ["NEWEST_NOTIFICATIONS"],
  ["CALLS"],
  ["INBOX"],
  ["LEADS_TABLE"],
  ["LEAD_ACTIVITY_LOG"],
  ["LEAD"]
];

export const invalidateFollowUpSurfaces = (queryClient: QueryClient) =>
  Promise.all(
    FOLLOW_UP_QUERY_ROOTS.map((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    )
  );
